exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table{font-size:.925em}.table td{padding:4px 10px!important}.table-xirr{width:auto}.txt-area{background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem}.form-cs-n{border:1px solid #c4c2c2;padding:13px;border-radius:7px;background-color:#f5faff}.date-pik{background-color:#fff!important;font-size:x-small}.form-z .vdp-datepicker{position:static!important}.time-horizon-cs{padding:0 4px!important}.v-select{width:100%;margin-left:10px}.dropdown-menu,.txt-fmt{font-size:small}.new-tbl-aaa-cs,.new-tbl-cs{appearance:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal;height:1.5rem;width:100%;height:1.9rem;padding:0 6px}.new-tbl-aaa-cs{margin:3px 0}.user-profiling label{margin-bottom:0;font-weight:400}.v-select li a{text-wrap:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-589813e1","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/acl/user-profiling.vue
// module id = 709
// module chunks = 27